"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePriceFetcher = void 0;
var react_1 = require("react");
function usePriceFetcher(_a) {
    var _b = _a.intervalSec, intervalSec = _b === void 0 ? 300 : _b, initialPrice = _a.price, priceRefresher = _a.priceRefresher;
    var _c = (0, react_1.useState)(initialPrice || 0), price = _c[0], setPrice = _c[1];
    (0, react_1.useEffect)(function () {
        if (priceRefresher) {
            var update = function () {
                return priceRefresher()
                    .then(setPrice)
                    .catch(function (e) { return console.error("failed to fetch price", e); });
            };
            update();
            var id_1 = setInterval(update, intervalSec * 1000);
            return function () { return clearInterval(id_1); };
        }
    }, [priceRefresher]);
    return price;
}
exports.usePriceFetcher = usePriceFetcher;
